program TMSWeb_FormHosting;



{$R *.dres}

uses
  WEBLib.Forms,
  uFrmMain in 'uFrmMain.pas'{*.html},
  uSubForm1 in 'uSubForm1.pas'{*.html},
  uSubForm2 in 'uSubForm2.pas'{*.html},
  Unit1 in 'Unit1.pas'{*.html},
  Unit2 in 'Unit2.pas'{*.html},
  Unit3 in 'Unit3.pas'{*.html},
  Unit4 in 'Unit4.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TFrmMain, FrmMain);
  Application.CreateForm(TForm1, Form1);
  Application.CreateForm(TForm2, Form2);
  Application.CreateForm(TForm3, Form3);
  Application.CreateForm(TForm4, Form4);
  Application.Run;
end.
